import React, { useEffect } from 'react'
import { createTheme, ThemeProvider } from '@material-ui/core'

import './App.css';
import { MainContextProvider } from './utils/context';
import MainRouter from './utils/routes';

function App() {

  useEffect(() => {

    var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
    (function () {
      var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/62542327b0d10b6f3e6ce52d/1g0cail50';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();
  }, []);

  return (
    <ThemeProvider theme={createTheme({
      palette: {
        primary: { 500: "#633064" },
        secondary: { A400: "#f4c53d" },
        white: { 500: "rgba(255,255,255)" },
      },
    })}>
      <MainContextProvider>
        <MainRouter />
      </MainContextProvider>
    </ThemeProvider>
  );
}

export default App;
